module.exports = __webpack_public_path__ + "Profile Settings.8002a404594997822210.png";